import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=04a216b9&scoped=true"
import script from "./Consumption.vue?vue&type=script&lang=js"
export * from "./Consumption.vue?vue&type=script&lang=js"
import style0 from "./Consumption.vue?vue&type=style&index=0&id=04a216b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a216b9",
  null
  
)

export default component.exports